import React from "react";
import styled from "styled-components";
import { Card, Statistic } from "antd";

const StatCard = ({
  title,
  value,
  prefix,
  suffix,
  valueStyle,
  precision = 0,
  textAlign = "center",
  formatter,
  children,
  ...props
}) => {
  return (
    <StyledStatCard $textAlign={textAlign} {...props}>
      {children || (
        <Statistic
          title={title}
          value={value}
          prefix={prefix}
          suffix={suffix}
          valueStyle={valueStyle}
          precision={precision}
          formatter={formatter}
        />
      )}
    </StyledStatCard>
  );
};

const StyledStatCard = styled(Card)`
  text-align: ${(props) => props.$textAlign};
  border-radius: 16px;
  border: 2px solid var(--color-border-light);
  box-shadow: 0 4px 20px rgba(44, 95, 45, 0.08);
  background: white;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 30px rgba(44, 95, 45, 0.15);
    border-color: var(--color-primary);
  }

  .ant-card-body {
    padding: 2rem;
  }

  .ant-statistic-title {
    font-family: var(--font-secondary);
    font-weight: 600;
    color: var(--color-text-light);
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
  }

  .ant-statistic-content {
    font-family: var(--font-primary);
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--color-text) !important;
  }

  .ant-statistic-content-value {
    color: var(--color-text) !important;
  }

  .ant-statistic-content-value-int {
    color: var(--color-text) !important;
  }

  .ant-statistic-content-value-decimal {
    color: var(--color-text) !important;
  }

  .ant-statistic-content-prefix {
    color: var(--color-text) !important;
    font-size: 1.5rem !important;
    font-weight: 700 !important;
    line-height: 1.2 !important;
  }

  .ant-statistic-content-suffix {
    color: var(--color-text) !important;
    font-size: 1.5rem !important;
    font-weight: 700 !important;
    line-height: 1.2 !important;
  }

  /* Parent pages can override via --stat-*-size; keep Doors/Payments defaults otherwise */
  &.stats-card {
    .ant-statistic-title {
      font-size: var(--stat-title-size, 0.875rem) !important;
      font-weight: 600 !important;
      line-height: 1.25;
    }
    .ant-statistic-content {
      font-size: var(--stat-value-size, 1.5rem) !important;
      font-weight: 700 !important;
      line-height: 1.1;
    }
    .ant-statistic-content-value,
    .ant-statistic-content-value-int,
    .ant-statistic-content-value-decimal {
      font-size: var(--stat-value-size, 1.5rem) !important;
      font-weight: 700 !important;
      line-height: 1.1;
    }
    .ant-statistic-content-prefix,
    .ant-statistic-content-suffix {
      font-size: var(--stat-suffix-size, 1.5rem) !important;
      font-weight: 700 !important;
      line-height: 1.2 !important;
    }
    .ant-statistic-content-prefix .anticon,
    .ant-statistic-content-prefix svg {
      font-size: var(--stat-icon-size, 1.5rem) !important;
      width: var(--stat-icon-size, 1.5rem) !important;
      height: var(--stat-icon-size, 1.5rem) !important;
    }
  }
`;

export default StatCard;
